<template>
  <div class="sidebar" :class="{ 'sidebar-collapsed': collapsed }">
    <div class="sidebar-header">
      <div class="logo-container">
        <img
          :src="collapsed ? miniLogoSrc : logoSrc"
          alt="NetNest Logo"
          class="logo-image"
        />
      </div>
      <!-- Sidebar toggle button -->
      <button
        class="sidebar-toggle"
        @click="toggleSidebar"
        :aria-label="collapsed ? 'Open sidebar' : 'Sluit sidebar'"
      >
        <svg
          v-if="collapsed"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9 6L15 12L9 18"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        <svg
          v-else
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15 6L9 12L15 18"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>
    </div>

    <nav class="sidebar-nav">
      <ul class="nav-list">
        <!-- Main subitems -->
        <template v-if="collapsed">
          <li class="nav-item">
            <router-link
              v-if="canViewAgenda"
              to="/agenda"
              class="nav-link"
              :title="'Agenda'"
            >
              <span class="nav-icon"><Calendar :stroke-width="1" /></span>
              <span class="nav-text">Agenda</span>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link
              v-if="canViewProjects"
              to="/projects"
              class="nav-link"
              :title="'Projects'"
            >
              <span class="nav-icon"><FolderOpen :stroke-width="1" /></span>
              <span class="nav-text">Projecten</span>
            </router-link>
          </li>
        </template>
        <template v-else>
          <li class="nav-item nav-item-dashboard">
            <span class="nav-link nav-link-dashboard" :title="'Main'">
              <span class="nav-icon"><LayoutList :stroke-width="1" /></span>
              <span class="nav-text" v-if="!collapsed">Main</span>
            </span>
            <ul class="sidebar-group-children">
              <li class="nav-item">
                <router-link
                  v-if="canViewAgenda"
                  to="/agenda"
                  class="nav-link"
                  :title="'Agenda'"
                >
                  <span class="nav-icon"><Calendar :stroke-width="1" /></span>
                  <span class="nav-text">Agenda</span>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  v-if="canViewProjects"
                  to="/projects"
                  class="nav-link"
                  :title="'Projects'"
                >
                  <span class="nav-icon"><FolderOpen :stroke-width="1" /></span>
                  <span class="nav-text">Projecten</span>
                </router-link>
              </li>
            </ul>
          </li>
        </template>
        <!-- Productivity subitems -->
        <template v-if="collapsed">
          <li class="nav-item" v-if="canViewProspectie">
            <router-link
              to="/prospectie"
              class="nav-link"
              :title="'Prospectie'"
            >
              <span class="nav-icon"><Search :stroke-width="1" /></span>
              <span class="nav-text">Prospectie</span>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link
              v-if="canViewDeals"
              to="/deals"
              class="nav-link"
              :title="'Deals'"
            >
              <span class="nav-icon"><Handshake :stroke-width="1" /></span>
              <span class="nav-text">Deals</span>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link
              v-if="canViewPlanning"
              to="/planning"
              class="nav-link"
              :title="'Planning'"
            >
              <span class="nav-icon"><CalendarCheck :stroke-width="1" /></span>
              <span class="nav-text">Planning</span>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link
              v-if="canViewTimetracker"
              to="/timetracker"
              class="nav-link"
              :title="'Timetracker'"
            >
              <span class="nav-icon"><Clock :stroke-width="1" /></span>
              <span class="nav-text">Timetracker</span>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link
              v-if="canViewTools"
              to="/tools"
              class="nav-link"
              :title="'Tools'"
            >
              <span class="nav-icon"><Wrench :stroke-width="1" /></span>
              <span class="nav-text">Tools</span>
            </router-link>
          </li>
        </template>
        <template v-else>
          <li class="nav-item nav-item-dashboard">
            <span class="nav-link nav-link-dashboard" :title="'Productivity'">
              <span class="nav-icon"><Gauge :stroke-width="1" /></span>
              <span class="nav-text" v-if="!collapsed">Productivity</span>
            </span>
            <ul class="sidebar-group-children">
              <li class="nav-item" v-if="canViewProspectie">
                <router-link
                  to="/prospectie"
                  class="nav-link"
                  :title="'Prospectie'"
                >
                  <span class="nav-icon"><Search :stroke-width="1" /></span>
                  <span class="nav-text">Prospectie</span>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  v-if="canViewDeals"
                  to="/deals"
                  class="nav-link"
                  :title="'Deals'"
                >
                  <span class="nav-icon"><Handshake :stroke-width="1" /></span>
                  <span class="nav-text">Deals</span>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  v-if="canViewPlanning"
                  to="/planning"
                  class="nav-link"
                  :title="'Planning'"
                >
                  <span class="nav-icon"
                    ><CalendarCheck :stroke-width="1"
                  /></span>
                  <span class="nav-text">Planning</span>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  v-if="canViewTimetracker"
                  to="/timetracker"
                  class="nav-link"
                  :title="'Timetracker'"
                >
                  <span class="nav-icon"><Clock :stroke-width="1" /></span>
                  <span class="nav-text">Timetracker</span>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  v-if="canViewTools"
                  to="/tools"
                  class="nav-link"
                  :title="'Tools'"
                >
                  <span class="nav-icon"><Wrench :stroke-width="1" /></span>
                  <span class="nav-text">Tools</span>
                </router-link>
              </li>
            </ul>
          </li>
        </template>
      </ul>
    </nav>

    <div class="sidebar-footer">
      <div class="user-profile" @click="showUserMenu = !showUserMenu">
        <div class="user-avatar">
          <template v-if="userAvatar">
            <img :src="userAvatar" alt="Avatar" class="user-avatar-img" />
          </template>
          <template v-else>
            <span>{{ userInitials }}</span>
          </template>
        </div>
        <div class="user-info" v-if="!collapsed">
          <div class="user-name">{{ userDisplayName }}</div>
          <div class="user-role">{{ userRoleLabel }}</div>
        </div>
        <div class="user-menu-toggle" v-if="!collapsed">
          <svg
            width="16"
            height="16"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M19 9l-7 7-7-7"
            ></path>
          </svg>
        </div>
      </div>

      <div class="user-menu" v-if="showUserMenu && !collapsed">
        <router-link to="/profile" class="menu-item">
          <svg
            width="16"
            height="16"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
            ></path>
          </svg>
          Profile
        </router-link>
        <router-link to="/settings" class="menu-item">
          <svg
            width="16"
            height="16"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
            ></path>
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
            ></path>
          </svg>
          Settings
        </router-link>
        <div class="menu-item theme-toggle-item">
          <span class="theme-label">Theme</span>
          <ThemeToggle />
        </div>
        <div class="menu-divider"></div>
        <a href="#" class="menu-item" @click.prevent="logout">
          <svg
            width="16"
            height="16"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
            ></path>
          </svg>
          Logout
        </a>
      </div>
    </div>

    <!-- Mobile overlay -->
    <div
      class="sidebar-overlay"
      v-if="isMobile && !collapsed"
      @click="toggleSidebar"
    ></div>
  </div>
</template>

<script>
import ThemeToggle from "./ThemeToggle.vue";
import SidebarGroup from "./ui/sidebar/SidebarGroup.vue";
import AuthService from "../services/auth.js";

import {
  ShieldUser,
  Gauge,
  LayoutDashboard,
  LayoutList,
  Calendar,
  Building2,
  Users2,
  FolderOpen,
  MapPin,
  Search,
  Star,
  Music,
  Mail,
  FileText,
  Handshake,
  CalendarCheck,
  Clock,
  Wrench,
  MessageSquareMore,
  User,
  Settings,
} from "lucide-vue-next";

export default {
  name: "Sidebar",
  components: {
    ThemeToggle,
    SidebarGroup,
    Gauge,
    LayoutDashboard,
    LayoutList,
    Calendar,
    Building2,
    Users2,
    FolderOpen,
    MapPin,
    Search,
    Star,
    Music,
    Mail,
    FileText,
    Handshake,
    CalendarCheck,
    Clock,
    Wrench,
    MessageSquareMore,
  },
  props: {
    collapsed: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showUserMenu: false,
      isMobile: false,
      theme:
        (typeof document !== "undefined" &&
          document.documentElement.getAttribute("data-theme")) ||
        "light",
      _themeObserver: null,
      displayedAvatar: null,
      chatUnreadCount: 0,
    };
  },
  computed: {
    canViewArticles() {
      return this.isAdmin || !!this.userRights.articles;
    },
    isAdmin() {
      // Controleer of de gebruiker een admin is
      return (
        this.currentUser &&
        (this.currentUser.role === "admin" ||
          this.currentUser.role === "administrator")
      );
    },
    isDev() {
      try {
        return Boolean(import.meta.env && import.meta.env.DEV);
      } catch (e) {
        return false;
      }
    },
    currentUser() {
      return AuthService.user;
    },
    userRights() {
      return (this.currentUser && this.currentUser.rights) || {};
    },
    canViewAgenda() {
      return this.isAdmin || !!this.userRights.agenda;
    },
    canViewCompanies() {
      return (
        this.isAdmin ||
        !!this.userRights.companies ||
        !!this.userRights.crmCompanies
      );
    },
    canViewContacts() {
      return (
        this.isAdmin ||
        !!this.userRights.contacts ||
        !!this.userRights.crmContacts
      );
    },
    canViewProjects() {
      return (
        this.isAdmin ||
        !!this.userRights.projectsInvoices ||
        !!this.userRights.projectsExpenses ||
        !!this.userRights.projectsSubscriptions
      );
    },
    canViewPlanning() {
      return this.isAdmin || !!this.userRights.planning;
    },
    canViewDeals() {
      return this.isAdmin || !!this.userRights.dealsOffertes;
    },
    canViewOffertes() {
      return this.isAdmin || !!this.userRights.dealsOffertes;
    },
    canViewTimetracker() {
      return this.isAdmin || !!this.userRights.timeTracking;
    },
    canViewTools() {
      return this.isAdmin || !!this.userRights.settings;
    },
    canViewChat() {
      return this.isAdmin || !!this.userRights.settings;
    },
    canViewProspectie() {
      return this.isAdmin || !!this.userRights.prospectie;
    },
    canViewInfluencers() {
      return this.isAdmin || !!this.userRights.crmCompanies;
    },
    canViewArtists() {
      try {
        return AuthService.canViewArtists && AuthService.canViewArtists();
      } catch (err) {
        return this.isAdmin;
      }
    },
    canViewEmailTemplates() {
      return this.isAdmin || !!this.userRights.crmMailing;
    },
    userAvatar() {
      return this.displayedAvatar || this.currentUser?.avatar || null;
    },
    userDisplayName() {
      return AuthService.getUserDisplayName();
    },
    userInitials() {
      if (!this.currentUser) return "U";
      if (this.currentUser.firstName && this.currentUser.lastName) {
        return `${this.currentUser.firstName[0]}${this.currentUser.lastName[0]}`.toUpperCase();
      }
      if (this.currentUser.username) {
        return this.currentUser.username.substring(0, 2).toUpperCase();
      }
      return "U";
    },
    userRoleLabel() {
      const roleLabels = {
        administrator: "Administrator",
        manager: "Manager",
        intern: "Intern",
      };
      return roleLabels[this.currentUser?.role] || "User";
    },
    logoSrc() {
      const variant = this.theme === "dark" ? "white" : "black";
      return encodeURI(`/assets/images/Logo - pms - ${variant}.svg`);
    },
    miniLogoSrc() {
      return "/assets/images/Logo.svg";
    },
  },
  methods: {
    toggleSidebar() {
      this.$emit("toggle-sidebar");
      this.showUserMenu = false;
    },
    checkMobile() {
      this.isMobile = window.innerWidth < 768;
      this.updateBodyClass();
    },
    updateBodyClass() {
      if (this.collapsed) {
        document.body.classList.add("sidebar-collapsed");
      } else {
        document.body.classList.remove("sidebar-collapsed");
      }
    },
    handleOutsideClick(event) {
      if (!this.$el.contains(event.target)) {
        this.showUserMenu = false;
      }
    },
    async logout() {
      try {
        this.showUserMenu = false;
        await AuthService.logout();
        this.$router.push("/login");
      } catch (error) {
        console.error("Logout error:", error);
        AuthService.clearAuthData();
        this.$router.push("/login");
      }
    },
    normalizeRoleForFallback(role) {
      if (!role) return "";
      const r = String(role).toLowerCase();
      if (r === "admin") return "administrator";
      if (r === "user" || r === "medewerker") return "employee";
      if (r === "intern" || r === "stagiair" || r === "stagair")
        return "intern";
      return r;
    },
  },
  mounted() {
    this.checkMobile();
    this.updateBodyClass();
    window.addEventListener("resize", this.checkMobile);
    this.displayedAvatar = AuthService.user?.avatar || null;
    this._authUpdateHandler = (e) => {
      try {
        this.displayedAvatar =
          (e && e.detail && e.detail.avatar) ||
          AuthService.user?.avatar ||
          null;
      } catch (err) {
        this.displayedAvatar = AuthService.user?.avatar || null;
      }
    };
    window.addEventListener("auth:user-updated", this._authUpdateHandler);
    try {
      const el = document.documentElement;
      this.theme = el.getAttribute("data-theme") || "light";
      this._themeObserver = new MutationObserver((mutations) => {
        for (const m of mutations) {
          if (m.type === "attributes" && m.attributeName === "data-theme") {
            this.theme = el.getAttribute("data-theme") || "light";
          }
        }
      });
      this._themeObserver.observe(el, {
        attributes: true,
        attributeFilter: ["data-theme"],
      });
    } catch (e) {}
    document.addEventListener("click", this.handleOutsideClick);
    this._chatUnreadListener = (event) => {
      this.chatUnreadCount = event.detail?.count || 0;
    };
    window.addEventListener(
      "chat-unread-count-changed",
      this._chatUnreadListener,
    );
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.checkMobile);
    document.removeEventListener("click", this.handleOutsideClick);
    document.body.classList.remove("sidebar-collapsed");
    if (this._themeObserver) this._themeObserver.disconnect();
    if (this._authUpdateHandler)
      window.removeEventListener("auth:user-updated", this._authUpdateHandler);
    if (this._chatUnreadListener) {
      window.removeEventListener(
        "chat-unread-count-changed",
        this._chatUnreadListener,
      );
    }
  },
  watch: {
    collapsed() {
      this.updateBodyClass();
    },
  },
};
</script>

<style scoped>
.sidebar {
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  width: 280px;
  background: var(--surface);
  border-right: 1px solid var(--border);
  box-shadow: 2px 0 10px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
  transition: all 0.3s ease;
  z-index: 1000;
}

.sidebar-hidden {
  transform: translateX(-100%);
  transition: transform 0.3s cubic-bezier(0.4, 0.8, 0.6, 1);
}

.sidebar-collapsed {
  width: 120px;
  min-width: 120px;
  max-width: 120px;
}

.sidebar-collapsed .nav-icon {
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  font-size: 20px;
}
.sidebar-collapsed .nav-icon svg {
  width: 20px !important;
  height: 20px !important;
  min-width: 20px !important;
  min-height: 20px !important;
  max-width: 20px !important;
  max-height: 20px !important;
}
.sidebar-collapsed .nav-link {
  justify-content: center;
  padding: 0.5rem 0;
  margin: 0;
}
.sidebar-collapsed .nav-text {
  display: none !important;
}
.sidebar-collapsed .logo-image {
  margin: 0 auto;
  display: block;
  height: 1.5rem;
  width: 1.5rem;
}
.sidebar-collapsed .user-avatar {
  margin: 0 auto;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.sidebar-header {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 1.5rem 1rem;
  border-bottom: 1px solid var(--border);
  min-height: 72px;
  transition: all 0.3s;
}
.sidebar-collapsed .sidebar-header {
  justify-content: center;
  padding-left: 0;
  padding-right: 0;
}

.logo-container {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  transition: all 0.3s ease;
}
.sidebar-collapsed .logo-container {
  justify-content: center;
}

.logo-image {
  flex-shrink: 0;
  height: 1.5rem;
  width: auto;
}

/* keep simple styling for image; explicit assets are used for theme variants */
.logo-image {
  transition: opacity 0.18s ease;
}

.sidebar-collapsed .logo-image {
  margin: 0 auto;
  display: block;
  height: 2rem;
  width: 2rem;
}

.logo-text {
  font-family: "NetNest-Medium", sans-serif;
  font-size: 1.5rem;
  font-weight: 300;
  color: var(--primary_color);
  opacity: 1;
  transition: opacity 0.3s ease;
}

.collapse-button {
  background: none;
  border: none;
  color: var(--text-secondary);
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 6px;
  transition: all 0.2s ease;
}

.collapse-button:hover {
  background: var(--surface-light);
  color: var(--text-primary);
}

/* Modern sidebar toggle button */
.sidebar-toggle {
  position: absolute;
  right: -12px;
  top: 50%;
  transform: translateY(-50%);
  width: 24px;
  height: 48px;
  background: var(--surface);
  border: 1px solid var(--border);
  border-left: none;
  border-radius: 0 12px 12px 0;
  color: var(--text-secondary);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.1);
  z-index: 1001;
}

.sidebar-toggle:hover {
  background: var(--surface-light);
  color: var(--primary_color);
  box-shadow: 2px 0 12px rgba(0, 0, 0, 0.15);
  transform: translateY(-50%) translateX(2px);
}

.sidebar-toggle:active {
  transform: translateY(-50%) translateX(1px);
}

.sidebar-nav {
  flex: 1;
  padding: 1rem 0;
  overflow-y: auto;
  scrollbar-width: none; /* Firefox */
}
.sidebar-nav::-webkit-scrollbar {
  display: none; /* Chrome, Safari, Opera */
}

.nav-list {
  list-style: none;
  margin: 0;
  padding: 0.5rem 1rem;
}

/* ...existing code... */
.nav-item {
  margin-bottom: 0.25rem;
}

/* Speciaal voor dashboard-item: geen extra margin links/rechts */
.nav-item-dashboard {
  margin-bottom: 0.25rem;
}

.nav-link {
  display: flex;
  align-items: center;
  padding: 0.875rem 1rem;
  color: var(--text-secondary);
  text-decoration: none;
  transition: all 0.2s ease;
  position: relative;
  margin: 0 0.5rem;
  border-radius: 8px;
  font-family: "Pptelegraf-Light", sans-serif;
  font-size: 0.875rem;
}

.nav-link-dashboard {
  margin-left: 0;
  margin-right: 0;
  padding-left: 0.75rem;
}

.nav-link:hover {
  background: var(--surface-light);
  color: var(--text-primary);
}

.nav-link.router-link-active {
  background: var(--primary_color_alpha_10);
  color: var(--primary_color);
  font-weight: 400;
}

.nav-link.router-link-active::before {
  content: "";
  position: absolute;
  left: -0.5rem;
  top: 50%;
  transform: translateY(-50%);
  width: 3px;
  height: 20px;
  background: var(--primary_color);
  border-radius: 0 2px 2px 0;
}

.nav-icon {
  flex-shrink: 0;
  margin-right: 0.75rem;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
}

.nav-icon-img {
  width: 20px;
  height: 20px;
  filter: brightness(0) invert(0.5); /* Makes icons grey by default */
  transition: filter 0.2s ease;
}

.nav-link:hover .nav-icon-img {
  filter: brightness(0) invert(1); /* Makes icons white on hover in dark mode */
}

/* Light mode override for hover icons */
[data-theme="light"] .nav-link:hover .nav-icon-img {
  filter: brightness(0) invert(0); /* Makes icons black on hover in light mode */
}

.nav-link.router-link-active .nav-icon-img {
  filter: brightness(0) saturate(100%) invert(40%) sepia(95%) saturate(4044%)
    hue-rotate(85deg) brightness(109%) contrast(110%);
}

/* Dark mode override for icons */
[data-theme="dark"] .nav-link.router-link-active .nav-icon-img {
  filter: none; /* Shows original green color when active in dark mode */
}

/* Light mode override for icons */
[data-theme="light"] .nav-link.router-link-active .nav-icon-img {
  filter: brightness(0) invert(0); /* Shows black color when active in light mode */
}

.sidebar-collapsed .nav-icon {
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
}
.sidebar-collapsed .nav-link {
  justify-content: center;
  padding: 0.75rem 0;
  margin: 0;
}
.sidebar-collapsed .nav-text {
  display: none !important;
}

.nav-text {
  font-weight: 500;
  font-size: 0.875rem;
  opacity: 1;
  transition: opacity 0.3s ease;
  flex: 1;
}

.coming-soon {
  background: var(--border);
  color: var(--text-secondary);
  font-size: 0.75rem;
  padding: 0.25rem 0.5rem;
  border-radius: 12px;
  font-weight: 500;
  margin-left: auto;
}

.sidebar-footer {
  border-top: 1px solid var(--border);
  padding: 1rem;
  position: relative;
}

.user-profile {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 0.75rem;
  border-radius: 8px;
  transition: all 0.2s ease;
}

.user-profile:hover {
  background: var(--surface-light);
}

.user-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: var(--primary_color);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--white);
  font-weight: 600;
  font-size: 0.9rem;
  margin-right: 0.75rem;
  flex-shrink: 0;
}

.user-avatar-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
  display: block;
}

.sidebar-collapsed .user-avatar {
  margin: 0 auto;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.sidebar-collapsed .user-info,
.sidebar-collapsed .user-menu-toggle,
.sidebar-collapsed .user-role,
.sidebar-collapsed .user-name {
  display: none !important;
}

.user-info {
  flex: 1;
  min-width: 0;
}

.user-name {
  font-weight: 600;
  color: var(--text-primary);
  font-size: 0.9rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.user-role {
  color: var(--text-secondary);
  font-size: 0.8rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.user-menu-toggle {
  color: var(--text-secondary);
  transition: transform 0.2s ease;
}

.user-menu {
  position: absolute;
  bottom: 100%;
  left: 1rem;
  right: 1rem;
  background: var(--surface-light);
  border: 1px solid var(--border);
  border-radius: 8px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  padding: 0.5rem;
  margin-bottom: 0.5rem;
}

.menu-item {
  display: flex;
  align-items: center;
  padding: 0.75rem;
  color: var(--text-secondary);
  text-decoration: none;
  border-radius: 6px;
  transition: all 0.2s ease;
  font-size: 0.9rem;
}

.menu-item:hover {
  background: var(--surface);
  color: var(--text-primary);
}

.menu-item svg {
  margin-right: 0.75rem;
  flex-shrink: 0;
}

.theme-toggle-item {
  justify-content: space-between;
  cursor: default;
}

.theme-toggle-item:hover {
  background: transparent;
}

.theme-label {
  font-size: 0.9rem;
  color: var(--text-secondary);
}

.menu-divider {
  height: 1px;
  background: var(--border);
  margin: 0.5rem 0;
}

.sidebar-debug {
  padding: 0.5rem 1rem;
  background: rgba(255, 255, 255, 0.03);
  color: var(--text-secondary);
  font-size: 0.75rem;
  border-bottom: 1px dashed var(--border);
}

.sidebar-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: -1;
}

/* Mobile Responsive */
@media (max-width: 768px) {
  .sidebar {
    transform: translateX(-100%);
  }

  .sidebar:not(.sidebar-collapsed) {
    transform: translateX(0);
    width: 280px;
  }

  .sidebar-collapsed {
    transform: translateX(-100%);
  }
}

/* Animation utilities */
@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.user-menu {
  animation: slideIn 0.2s ease;
}
/* Vertical line for grouping child items under each SidebarGroup */
.sidebar-group-children {
  position: relative;
  margin-left: 1.25rem;
  padding-left: 0.75rem;
}
.sidebar-group-children::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 2px;
  background: var(--border);
  border-radius: 2px;
  opacity: 0.5;
}

/* Chat unread messages badge */
.chat-unread-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  background: var(--primary_color);
  color: black;
  font-size: 0.7rem;
  font-weight: 600;
  border-radius: 50%;
  margin-left: auto;
  flex-shrink: 0;
}
</style>
